import React from 'react';

class NotFoundPage extends React.Component {
  render() {
    return (
      <div className="site-page">
        <div className="site-page-section" style={{padding: '20px'}}>
          <div>This is not the page you are looking for...</div>
        </div>
      </div>
    )
  }
}

export default NotFoundPage;